'use client';

import React, { useEffect, useState } from 'react';

import { UsernameEmailSafetyModal } from '@/components/UsernameEmailSafetyModal';
import { useCurrentUser } from '@/modules/user/useCurrentUser';
import { setUsernameEmailSafetyPromptStatus } from '@/modules/usernameEmailSafety/helpers/setUsernameEmailSafetyPromptStatus';
import { useUsernameEmailSafetyEligibility } from '@/modules/usernameEmailSafety/useUsernameEmailSafetyEligibility';
import { useUsernameEmailSafetyTracking } from '@/modules/usernameEmailSafety/useUsernameEmailSafetyTracking';

export function UsernameEmailSafetyModalContainer() {
  const eligible = useUsernameEmailSafetyEligibility();
  const [, user] = useCurrentUser();
  const {
    sendPromptView,
    sendPromptUpdateUsernameAction,
    sendPromptDismissAction,
  } = useUsernameEmailSafetyTracking();
  const [hasShown, setHasShown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (eligible && !hasShown) {
      setIsOpen(true);
      setHasShown(true);
      sendPromptView();
    }
  }, [eligible, hasShown, sendPromptView]);

  function persistDismissal() {
    setIsOpen(false);
    if (user?.id) {
      setUsernameEmailSafetyPromptStatus(user.id);
    }
  }

  function handleClose() {
    sendPromptDismissAction();
    persistDismissal();
  }

  function handleUpdateUsernameClick() {
    sendPromptUpdateUsernameAction();
    persistDismissal();
  }

  return (
    <UsernameEmailSafetyModal
      isOpen={isOpen}
      onClose={handleClose}
      onUpdateUsernameClick={handleUpdateUsernameClick}
    />
  );
}
